import React, { useState, useEffect } from "react";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { getServices, deleteService } from "../../../api/service";
import { usePagination } from "../../../hooks/usePagination";
import PaginationHandler from "../../../components/PaginationHandler";
import CustomTable from "../../../components/CustomTable/CustomTable";
import { Button } from "reactstrap";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";

export default function ServiceList() {
  const navigate = useNavigate();
  const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
  const role = currentUser.role || currentUser.roleName || "";
    const hasPermission = (action) => {
        if (role.name === "super admin") return true;
        return (
            role.permissions &&
            role.permissions.some(
                (perm) => perm.resource === "Sales" && perm.actions.includes(action)
            )
        );
    };

    const canCreate = () => hasPermission("create");
    const canEdit = () => hasPermission("update");
    const canDelete = () => hasPermission("delete");
    const canRead = () => hasPermission("read");
  useEffect(() => {
    console.log("Current User:", currentUser);
    console.log("Role:", role.name);
    console.log("Permissions:", role.permissions);
    console.log("canCreate:", canCreate());
    console.log("canEdit:", canEdit());
    console.log("canDelete:", canDelete());
    console.log("canRead:", canRead());
  }, [currentUser]);

  const {
    response,
    loading,
    error,
    setPage,
    page,
    setMeta,
    totalPages,
  } = usePagination(getServices, null, true);

  const [filters, setFilters] = useState({
    name: "",
  });

  function handleFilter() {
    setMeta((m) => ({
      ...m,
      page: 1,
      payload: {
        ...filters,
      },
    }));
  }

  const handleDelete = async (id) => {
    if (window.confirm(t("Are you sure you want to delete this service?"))) {
      try {
        await deleteService(id);
        setPage(1);
      } catch (error) {
        console.error("Delete failed:", error);
        alert(t("Failed to delete service."));
      }
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs
          title={t("Services")}
          addUrl={canCreate() ? "/services/add/" : null}
          hasAddBtn={canCreate()}
          isMainPage={true}
        />

        {canRead() || canDelete() || canEdit() ? (
          response && response.length > 0 && !loading ? (
            <CustomTable
              emptyMsg={t("No Services Found.")}
              data={response}
              loading={loading}
              error={error}
              cols={[
                {
                  label: t("Names"),
                  key: "names",
                  style: { width: "50%" },
                  renderer: (row) => row.names.join(", "),
                },
                {
                  label: t("Actions"),
                  key: "actions",
                  style: { width: "40%" },
                  renderer: (row) => (
                    <div className="d-flex gap-2">
                      {canEdit() && (
                        <Button
                          color="info"
                          size="sm"
                          onClick={() => navigate(`/services/edit/${row._id}`)}
                        >
                          {t("Edit")}
                        </Button>
                      )}
                      {canDelete() && (
                        <Button
                          color="danger"
                          size="sm"
                          onClick={() => handleDelete(row._id)}
                        >
                          {t("Delete")}
                        </Button>
                      )}
                    </div>
                  ),
                },
              ]}
            />
          ) : (
            !loading && <div>{t("No results found.")}</div>
          )
        ) : (
          <div>{t("You do not have permission to view this list.")}</div>
        )}

        {response && !loading && canRead() && (
          <PaginationHandler page={page} setPage={setPage} totalPages={totalPages} />
        )}
      </div>
    </div>
  );
}
